import React, { FC, ReactNode } from 'react';

import withNoScrollOnActive from '../../../hocs/withNoScrollOnActive';
import Icon from '../../assets/icons';

import {
  FlyoutCloser,
  FlyoutCrossWrapper,
  FlyoutTitle,
  FlyoutTitleWrapper,
  StyledFlyout,
} from './styles';

interface IProps {
  isActive?: boolean;
  onClose?: () => void;
  children: ReactNode;
  title: string;
}

const Flyout: FC<IProps> = ({ children, isActive, onClose, title }) => (
  <>
    <FlyoutCloser
      $isActive={isActive}
      onClick={onClose}
    />
    <StyledFlyout $isActive={isActive}>
      <FlyoutTitleWrapper>
        <FlyoutCrossWrapper onClick={onClose}>
          <Icon variant="cross" />
        </FlyoutCrossWrapper>
        <FlyoutTitle>{title}</FlyoutTitle>
      </FlyoutTitleWrapper>

      {children}
    </StyledFlyout>
  </>
);

export default withNoScrollOnActive(Flyout);
